import React from 'react';
import { useNavigate } from 'react-router-dom';
import LandingNav from '../../components/LandingNav';
import LandingFooter from '../../components/LandingFooter';
import '../../styles/blog.css';

export default function BlogNotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <LandingNav />
      <main className="blog-container">
        <div className="blog-header">
          <h1 className="blog-title">Blog post not found</h1>
          <p className="blog-subtitle">That link might be outdated, or the post isn’t published yet.</p>
          <div className="blog-header-actions">
            <button className="blog-btn secondary" onClick={() => navigate('/blog')}>
              Back to Blog
            </button>
            <button className="blog-btn primary" onClick={() => navigate('/contact')}>
              Contact
            </button>
          </div>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
}

